import { TagsService } from '../../services';
import { AppThunk } from '../store';
import { tagsActions } from './tagsSlice';

export const initTagsAction = (): AppThunk => async dispatch => {
  const globalTags = await TagsService.getGlobalTags();

  dispatch(tagsActions.acceptGlobalTags(globalTags));
};
